export default __webpack_public_path__ + "static/media/tiktag-simple.3be91939.svg";